import React, { useMemo } from 'react';
import useLocationMock from './useLocationMock';
import useHistoryMock from './useHistoryMock';
import useParamsMock from './useParamsMock';
const DEFAULT_STATIC_CONTEXT = {};
const withRouterMock = WrappedComponent => function WithRouter(props) {
  const location = useLocationMock();
  const history = useHistoryMock();
  const params = useParamsMock();
  const matchObject = useMemo(() => {
    return {
      isExact: true,
      params: params && typeof params === 'object' ? {
        ...params
      } : {},
      path: location.pathname,
      url: location.pathname
    };
  }, [location.pathname, params]);
  return <WrappedComponent {...props} match={matchObject} history={history} staticContext={DEFAULT_STATIC_CONTEXT} location={location} />;
};
export default withRouterMock;